
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"notificationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationObject"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notificationType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeInterval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeFrom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeTo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"units"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geofences"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"notificationObject"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notificationType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeInterval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeFrom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeTo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"units"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geofences"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstCondition"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"secondCondition"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"frequency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstConditionType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstConditionValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"secondConditionType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"secondConditionValue"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":647}};
    doc.loc.source = {"body":"fragment notificationFragment on Notification {\n  notificationObject\n    name\n    notificationType\n    message\n    timeInterval\n    timeFrom\n    timeTo\n    id\n    units\n    geofences\n    groups\n    emails\n    configuration {\n      type\n      value\n    }\n    notificationObject\n    name\n    notificationType\n    message\n    timeInterval\n    timeFrom\n    timeTo\n    id\n    units\n    geofences\n    groups\n    emails\n    firstCondition\n    secondCondition\n    operator\n    frequency\n    configuration {\n      type\n      subType\n      value\n      firstConditionType\n      firstConditionValue\n      secondConditionType\n      secondConditionValue\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["notificationFragment"] = oneQuery(doc, "notificationFragment");
        
